/* eslint no-underscore-dangle: ["error", { "allow": ["_meta"] }] */
import { React } from '@biletiniz/ui-core';
import { NextSeo, FAQPageJsonLd, BreadcrumbJsonLd } from '@biletiniz/seo';
import Head from 'next/head';
import { BusesHomePage } from '@biletiniz/web-app-containers';
import { busTicketFAQ, getCleanFaqJsonid } from '@biletiniz/web-app-utils';
import { useI18n } from '@biletiniz/intl';
import { useHotBusBlogs } from '../src/hooks';

const BusHomePages = ({ hotBusBlogs }) => {
  const i18n = useI18n();
  return (
    <>
      <NextSeo
        title="Cheap Bus Ticket Booking Online, Prices & Schedules - Biletiniz"
        description="Compare and book cheap bus tickets online in Turkey! Search bus ticket prices, schedules, and routes from top bus companies. Buy your ticket safely."
        canonical={`https://biletiniz.com/en/bus-ticket`}
      />
      <Head>
        <meta
          name="keywords"
          content="bus ticket, cheap bus tickets, bus ticket booking, online bus ticket booking, bus ticket prices, buy bus tickets online"
        />
      </Head>
      <FAQPageJsonLd
        mainEntity={Object.values(
          busTicketFAQ[`${i18n.activeLocale}`] || {}
        ).map(item => ({
          questionName: getCleanFaqJsonid(item?.question),
          acceptedAnswerText: getCleanFaqJsonid(item?.answer),
        }))}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: i18n.t(`goToHome`),
            item: 'https://biletiniz.com/',
          },
          {
            position: 2,
            name: i18n.t(`busTicket`),
            item: 'https://biletiniz.com/en/bus-ticket',
          },
        ]}
      />
      <BusesHomePage hotBusBlogs={hotBusBlogs} />
    </>
  );
};

export async function getStaticProps(context) {
  const { default: lngDict = {} } = await import(
    `@biletiniz/intl/locales/${context.locale}.json`
  );
  const data = await useHotBusBlogs();

  return {
    props: {
      lng: context.locale,
      lngDict,
      hotBusBlogs: data.hotBusBlogs,
    },
  };
}

export default BusHomePages;
